import { createSelector } from 'reselect';
import {
    get, has,
} from 'lodash';
/**
 * Base Selectors
 */
const getEntityId = (state, id) => id;
const getEntities = (state) => get(state, 'app.database.zinrelos', {});
/**
 * Selector Builders
 */
export const buildZinrelosSelector = () => createSelector([
    getEntityId,
    getEntities,
], (entityId, entities) =>
{
    if (has(entities, entityId))
    {
        const zinrelo = entities[entityId];

        return {
            ...zinrelo,
        };
    }

    return {};
});
